export const onboardingColors = {
  primary: '#0F8F6F',
  accent: '#FF8A3D',
  background: '#F7F7F5',
  text: '#1E1E1E',
  textSecondary: '#6B6B6B',
  dot: '#D1D1D1',
  dotActive: '#0F8F6F',
  white: '#FFFFFF',
};
